import { makeStyles } from '@mui/styles';

export default makeStyles({
  root: {
    whiteSpace: 'normal',
  },
});
